<form class="container pt-5"
      (ngSubmit)="registerUser()"
      #createAccountForm="ngForm"
      name="registerUser"
      method="post"
      novalidate>

    <div class="card text-bg-secondary mb-3 registration-card">
        <div class="card-body">
            <div class="container">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-10">
                        <h1 class="card-header ps-0">User Registration</h1>
                    </div>
                    <div class="col"></div>
                </div>
                <div class="row">
                    <div class="col"></div>
                    <div class="col-10">
                        <h5 class="card-title">Let's establish your credentials</h5>
                        <div id="errorSummary"
                             class="text-danger"
                             [innerHTML]="errorList.outerHTML"></div>
                        <div class="mb-3">
                            <label for="email" class="form-label">Email address</label>
                            <input type="email"
                                   class="form-control"
                                   id="email"
                                   name="email"
                                   [(ngModel)]="model.email"
                                   #email="ngModel"
                                   aria-describedby="emailHelp"
                                   [required]="true"
                                   email />
                            <span id="clientEmailErrorMsg"
                                  class="text-danger"
                                  *ngIf="email.invalid && (email.dirty || email.touched)">
                                <span *ngIf="email.errors?.['required']">Email is required.</span>
                                <span *ngIf="email.errors?.['email']">Invalid email address.</span>
                            </span>
                            <span id="serverEmailErrorMsg" class="text-danger">
                                {{emailErrorMsg}}
                            </span>
                            <div id="emailHelp" class="form-text">
                                We'll never share your email with anyone else.
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="preferredName" class="form-label">Username</label>
                            <input type="text"
                                   class="form-control"
                                   id="preferredName"
                                   name="preferredName"
                                   [(ngModel)]="model.preferredName"
                                   #preferredName="ngModel"
                                   aria-describedby="preferredNameHelp"
                                   (ngModelChange)="checkPrefferedName()" />
                            <span id="clientPreferredNameErrorMsg" class="text-danger" *ngIf="preferredName.invalid && (preferredName.dirty || preferredName.touched)">
                                <span *ngIf="preferredName.errors?.['invalidLength']">Invalid preferredName. Maximum length is 20 characters.</span>
                            </span>
                            <span id="serverPreferredNameErrorMsg" class="text-danger">{{preferredNameErrorMsg}}</span>
                            <div id="preferredNameHelp" class="form-text">
                                What would you like us to call you? Providing a username
                                is optional. If you prefer not to, we'll refer to you by your email
                                address instead.
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="password" class="form-label">Password</label>
                            <input type="password"
                                   class="form-control"
                                   id="password"
                                   name="password"
                                   data-testid="password"
                                   [(ngModel)]="model.password"
                                   #password="ngModel"
                                   required
                                   pattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?=(?:.*(.)(?!\1)){4}).{8,}$"
                                   (ngModelChange)="checkPasswords()" />
                            <span id="clientPasswordErorMsg"
                                  class="text-danger"
                                  *ngIf="
                        password.invalid && (password.dirty || password.touched)
                      ">
                                <span *ngIf="password.errors?.['required']">Password is required.</span>
                                <span *ngIf="password.errors?.['pattern']">
                                    Password must be at least 8 characters long, contain at
                                    least one numeric digit, one lowercase character, one
                                    uppercase character, one non-alphanumeric character, and
                                    have at least 4 distinct characters.
                                </span>
                            </span>
                            <span id="serverPasswordErorMsg" class="text-danger">
                                {{
                                passwordErrorMsg
                                }}
                            </span>
                        </div>
                        <div class="mb-3">
                            <label for="confirmPassword" class="form-label">Confirm Password</label>
                            <input type="password"
                                   class="form-control"
                                   id="confirmPassword"
                                   name="confirmPassword"
                                   data-testid="confirmPassword"
                                   [(ngModel)]="model.confirmPassword"
                                   #confirmPassword="ngModel"
                                   required
                                   (ngModelChange)="checkPasswords()" />
                            <span id="clientConfirmPasswordErrorMsg"
                                  class="text-danger"
                                  *ngIf="
                        confirmPassword.invalid &&
                        (confirmPassword.dirty || confirmPassword.touched)
                      ">
                                <span *ngIf="confirmPassword.errors?.['required']">Confirm Password is required.</span>
                                <span *ngIf="confirmPassword.errors?.['passwordMismatch']">Passwords do not match.</span>
                            </span>
                            <span id="serverConfirmPasswordErrorMsg"
                                  class="text-danger">{{ confirmPasswordErrorMsg }}</span>
                        </div>
                        <button type="submit" class="btn btn-primary" [disabled]="createAccountForm.invalid">Register</button>
                    </div>
                    <div class="col"></div>
                </div>
            </div>
        </div>
    </div>
</form>
